import React, { Component } from 'react'
import axios from 'axios'
import greenMark from '../../images/green_mark.svg'

class Screen8 extends Component {

  state = {
    status: <h2>Prijava se šalje...</h2>
  }

  componentDidMount() {
    let app = this
    const { language, t } = this.props
    let formData = new FormData()

    Object.keys(this.props.entry).map(e =>
      formData.set(e, this.props.entry[e])
    )
    axios.post('https://dostajemrznje.org/api/save', formData)
    .then(function (response) {
      app.setState({status: <div>
          <img src={greenMark} alt={t(language, 'logo')} />
          <h2>{t(language, 'successTitle')}</h2>
          <h2>{t(language, 'thanks')}</h2>
          <p style={{textAlign: 'center'}}>{t(language, 'reviewTeam')}<br />{t(language, 'checkStatusHere')} <button style={{fontSize: 16}} onClick={() => app.props.goTo(1)}>{t(language, 'here')}</button>.</p>
        </div>})
    })
    .catch(function (error) {
      app.setState({status: <h3><br /><br />{t(language, 'errorSubmitting')}<br /><br />{t(language, 'tryAgain')}</h3>})
    });
  }

  render() {

    return (
      <main className="last_screen">
        {this.state.status}
      </main>
    );
  }
}

export default Screen8;
